export class DataServiceStatic{
    public static staticMap;
    public static Constants
}